import gql from "graphql-tag";

export const CustomGetConversationV2 = gql`
  query GetConversationV2($id: String, $messageLimit: Int, $messageNextToken: String) {
    getConversationV2(id: $id) {
      id
      name
      conversation_type
      description
      icon
      invite_approval_type
      notification_range
      created_at
      updated_at
      importance
      has_unread
      has_guest_unread
      last_talk_at
      is_anonymous_join
      conversation_detail {
        conversation_name
        fix_flg
        role
        p2p_peer {
          access_id
          icon
        }
      }
      members(limit: 10) {
        items {
          id
          id_account
          role
          join_status
          notification_range
          user {
            access_id
            lang_cd
            name
            is_official
          }
        }
        nextPage
      }
      messages(limit: $messageLimit, nextToken: $messageNextToken) {
        items {
          id
          authorId
          content
          messageConversationId
          translatedContents
          originalLangCd
          translating
          reTranslatedContents
          reTranslateRequestIdMap
          reTranslateCompleteMap
          order
          isGuestUnread
          createdAt
          updatedAt
          isMasked
          displayTo
          manualMaskingStatus
          linkedMessageId
          linkedMessageContents {
            contents
            translatedContents
          }
          action {
            is_hidden
            report_status
          }
          user {
            id_account
            access_id
            name
            lang_cd
            icon
            user_type
            is_official
          }
          contents {
            mention
          }
        }
        nextToken
      }
      biz_conv_info {
        conversation_id
        state
        close_chat_state
        inquiry_id
        assign_staff_id_account
        staff_conversation_id
        inquiry_trigger
        responder_id
        responder_name
        created_at
        updated_at
        is_sms_chat
        guest {
          id
          code
          location_id
          phone_number
          state
          available_from
          available_to
          conversation_id
          qr
          qr_with_lang
          name
          lang_cd
          receive_notice
          room_name {
            name
          }
        }
        staff_qc_user {
          id_account
          access_id
          name
          lang_cd
          icon
          user_type
          email
          qr
          sign_up_at
          activation_type
          mode
          online_status
          notification_email
          notification_push
          created_at
          updated_at
        }
        forward_target_name
        inquiry {
          is_check_out
          change_location
          inquiry_type
          staff_group_names
          location_group {
            id
            tenant_id
            name
            display_name
            is_default
            is_show_chat_history
            color
          }
          sub_menu {
            name
          }
        }
      }
      cc_status {
        status
        reject_comment
      }
      design {
        conversation_id
        title_bar_txt_color
        title_bar_bg_color
      }
    }
  }
`;
